import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function NewsletterForm({ dark = false }) {
  const [firstName, setFirstName] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!firstName || !email) return;
    setLoading(true);
    try {
      const r = await api.post("/newsletter/subscribe", { first_name: firstName, email });
      toast.success(r.data.message || "Subscribed!");
      setFirstName("");
      setEmail("");
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const inputBase = dark
    ? "bg-cream/10 border-cream/25 text-cream placeholder:text-cream/45 focus:border-gold focus:bg-cream/15"
    : "bg-white border-sand text-ink placeholder:text-ink/40 focus:border-emerald_deep";

  return (
    <form onSubmit={submit} className="flex flex-col gap-2.5" data-testid="newsletter-form">
      <input
        type="text"
        placeholder="First name"
        value={firstName}
        onChange={(e) => setFirstName(e.target.value)}
        required
        data-testid="newsletter-firstname"
        className={`w-full px-4 py-2.5 rounded-full border text-sm outline-none transition-colors ${inputBase}`}
      />
      <input
        type="email"
        placeholder="Email address"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
        data-testid="newsletter-email"
        className={`w-full px-4 py-2.5 rounded-full border text-sm outline-none transition-colors ${inputBase}`}
      />
      <button
        type="submit"
        disabled={loading}
        data-testid="newsletter-submit"
        className="rounded-full bg-gold text-emerald_deep px-5 py-2.5 text-sm font-semibold uppercase tracking-wider hover:bg-gold-600 transition-colors disabled:opacity-60"
      >
        {loading ? "…" : "Subscribe"}
      </button>
    </form>
  );
}
